module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("TOOLS")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Pagina Inicial")])])]), _vm._v(" "), (_vm.possuiAgendamento) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/calendario"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Calendário")])])]) : _vm._e(), _vm._v(" "), (_vm.possuiDelivery) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/pedidos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Pedidos")])])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/clientes"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Clientes")])])]), _vm._v(" "), (_vm.possuiDelivery) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/produtos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-cubes",
    staticStyle: {}
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Produtos")])])]) : _vm._e(), _vm._v(" "), (_vm.possuiAgendamento) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/servicos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-wrench"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Servicos")])])]) : _vm._e(), _vm._v(" "), (_vm.possuiDelivery) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/categorias"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-tags"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Categorias de Produtos")])])]) : _vm._e(), _vm._v(" "), (_vm.possuiAgendamento) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/categorias-servicos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-tags"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Categorias de Serviços")])])]) : _vm._e(), _vm._v(" "), (_vm.possuiDelivery) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/campanhas"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-facebook"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Campanhas")])])]) : _vm._e(), _vm._v(" "), (_vm.possuiAgendamento) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/colaborador"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-id-card-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Colaborador")])])]) : _vm._e(), _vm._v(" "), (_vm.possuiAssistencia) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/problemas"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-lightbulb-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Problemas/Solução")])])]) : _vm._e(), _vm._v(" "), (_vm.possuiTurismo) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/solicitacoes"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-list-ul"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Solicitações")])])]) : _vm._e(), _vm._v(" "), (_vm.possuiTurismo) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/pacotes"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-suitcase"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Pacotes de Viagem")])])]) : _vm._e(), _vm._v(" "), (_vm.possuiTurismo) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/perguntas"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Perguntas Personalizadas")])])]) : _vm._e(), _vm._v(" "), (_vm.possuiTurismo) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/filtros"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Filtros")])])]) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/inclusao-rapida-produtos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Produtos (inclusão rápida)")])])]) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/inclusao-rapida-categorias"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Categorias (inclusão rápida)")])])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "header"
  }, [_vm._v("SETTINGS")]), _vm._v(" "), (_vm.possuiDelivery) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/setting"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Configurações")])])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/help"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-question-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Ajuda")])])]), _vm._v(" "), _c('li', {
    staticClass: "header"
  }, [_vm._v("EMPRESAS")]), _vm._v(" "), _vm._l((_vm.options), function(empresa, index) {
    return _c('li', {
      staticClass: "pageLink",
      attrs: {
        "tag": "li"
      }
    }, [_c('a', {
      class: [index === _vm.empresa_ativa ? 'empresaLink' : ''],
      on: {
        "click": function($event) {
          return _vm.changeEmpresa(index, empresa.fb_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-building-o iconEmpresa"
    }), _vm._v(" "), _c('span', {
      staticClass: "page"
    }, [_vm._v(_vm._s(empresa.nome))])])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32729fe4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarMenu.vue
// module id = 1226
// module chunks = 1